import React, { useEffect, useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";
import jsPDF from "jspdf";

import { autoTable } from "jspdf-autotable";
import addGujaratiFont from "../fonts/NotoSansGujarati";
const Exam = ({ questions, testid, userid }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState([]);
  const [finish, setFinish] = useState(false);
  const [reviewMode, setReviewMode] = useState(false);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(""); // success | error
  const [message, setMessage] = useState("");

  const fullname = localStorage.getItem("fullname");

  const [testDetail, setTestDetail] = useState({
    TEST_NAME: "",
    TEST_DATE: "",
    TEST_TIME: "",
  });

  const Test_ID = testid;
  const UID = userid;
  const LANGUAGE_ID = 2;

  /* ================= FETCH TEST DETAIL ================= */
  useEffect(() => {
    if (!Test_ID) return;

    const fetchTestDetail = async () => {
      try {
        const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_TEST_DETAIL}`;
        const res = await fetch(path, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ TEST_UID: Test_ID }),
        });
        const data = await res.json();
        if (data.res === "success") {
          setTestDetail({
            TEST_NAME: data.TEST_NAME,
            TEST_DATE: data.TEST_DATE,
            TEST_TIME: data.TEST_TIME,
          });
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchTestDetail();
  }, [Test_ID]);

  /* ================= BLOCK COPY ================= */
  useEffect(() => {
    const block = (e) => e.preventDefault();
    document.addEventListener("contextmenu", block);
    document.addEventListener("copy", block);
    document.addEventListener("cut", block);
    document.addEventListener("paste", block);
    return () => {
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("copy", block);
      document.removeEventListener("cut", block);
      document.removeEventListener("paste", block);
    };
  }, []);

  /* ================= PREVENT TAB CLOSE WHILE SUBMIT ================= */
  useEffect(() => {
    if (loading) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
  }, [loading]);

  const currentQ = questions[currentIndex];

  const selectOption = (opt) => {
    if (!finish) {
      setAnswers({ ...answers, [currentQ.QUE_UID]: opt });
    }
  };

  const buildFinalPayload = () =>
    questions.map((q) => ({
      QUE_ID: q.QUE_UID,
      SUBMITTED: answers[q.QUE_UID] || "",
      RIGHT: q.RIGHT_ANS,
      ISCORRECT: answers[q.QUE_UID] === q.RIGHT_ANS ? "R" : "W",
    }));

  /* ================= SUBMIT TEST ================= */
  const submitTest = async () => {
    setLoading(true);
    setStatus("");
    setMessage("Submitting test...");

    const finalAnswers = buildFinalPayload();
    const payload = {
      Test_ID,
      UID,
      LANGUAGE_ID,
      SUBMITED: finalAnswers,
    };

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_SUBMIT_TEST}`;
      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.res !== "Success" && data.res !== "success") {
        throw new Error("Submit failed");
      }

      setSubmitted(finalAnswers);
      setFinish(true);
      setStatus("success");
      setMessage("✅ Test submitted successfully");
    } catch (err) {
      console.error(err);
      setStatus("error");
      setMessage("❌ Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= PDF ================= */
  const downloadPDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4"); // landscape
addGujaratiFont(doc); // register font first
    doc.setFont("NotoGujarati", "normal");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const total = questions.length;
  const correct = submitted.filter((q) => q.ISCORRECT === "R").length;
  const wrong = total - correct;

  // Heading
  let y = 15;
  doc.setFontSize(18);
  doc.text("EasyITI Examination Result", pageWidth / 2, y, { align: "center" });
  y += 10;

  doc.setFontSize(12);
  doc.text(`Test Name : ${testDetail.TEST_NAME}`, 14, y);
  doc.text(`Student Name : ${fullname}`, pageWidth - 14, y, { align: "right" });

  y += 6;
  doc.text(`Test Date : ${testDetail.TEST_DATE}`, 14, y);
  doc.text(`Test Time : ${testDetail.TEST_TIME}`, pageWidth - 14, y, { align: "right" });

  y += 10;
  doc.line(14, y, pageWidth - 14, y);
  y += 6;

  // Prepare table data
  const tableData = questions.map((q, index) => {
    const userAns = answers[q.QUE_UID] || "Not Attempted";
    return [
      index + 1,
      q.QUESTION,
      `A) ${q.OPT1}`,
      `B) ${q.OPT2}`,
      `C) ${q.OPT3}`,
      `D) ${q.OPT4}`,
      q.RIGHT_ANS,
      userAns
    ];
  });

  // Add table
  autoTable(doc, {
    startY: y,
    head: [["No", "Question", "Option A", "Option B", "Option C", "Option D", "Correct", "Your Answer"]],
    body: tableData,
    styles: {
        font: "NotoGujarati",
        fontStyle: "normal",
        fontSize: 10,
        cellPadding: 2,
        overflow: "linebreak",
      },
    headStyles: { fillColor: [13, 110, 253], textColor: 255 },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 80 }, // thodu vadhu question column
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 30 },
        5: { cellWidth: 30 },
        6: { cellWidth: 25 },
        7: { cellWidth: 25 },
      },
    margin: { left: 14, right: 14 }
  });

  // Add Result Summary
  doc.addPage();
  y = 20;
  doc.setFontSize(16);
  doc.text("Result Summary", pageWidth / 2, y, { align: "center" });
  y += 15;

  doc.setFontSize(12);
  doc.text(`Total Questions : ${total}`, 20, y);
  y += 10;
  doc.text(`Correct : ${correct}`, 20, y);
  y += 10;
  doc.text(`Wrong : ${wrong}`, 20, y);

  doc.save(`EasyITI_Result_${Test_ID}.pdf`);
  };

  /* ================= UI ================= */
  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />

      {/* ===== SUBMIT WAITING OVERLAY ===== */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            flexDirection: "column",
          }}
        >
          <div className="spinner-border text-light mb-3" />
          <h5>Submitting your test…</h5>
          <p>Please wait, do not close this tab</p>
        </div>
      )}

      {/* ===== RESULT ===== */}
      {finish && !reviewMode && (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
          <div
            className="card p-4 shadow text-center"
            style={{ maxWidth: 500 }}
          >
            <h3 className="text-success">Result 📊</h3>
            <p>Total Questions: {questions.length}</p>
            <p>Attempted: {Object.keys(answers).length}</p>
            <p>
              Correct: {submitted.filter((q) => q.ISCORRECT === "R").length}
            </p>
            <p>
              Wrong:{" "}
              {questions.length -
                submitted.filter((q) => q.ISCORRECT === "R").length}
            </p>

            <button className="btn btn-success mt-3" onClick={downloadPDF}>
              ⬇ Download PDF
            </button>

            <button
              className="btn btn-primary mt-3 ms-2"
              onClick={() => setReviewMode(true)}
            >
              Review Answers 🧠
            </button>
          </div>
        </div>
      )}

      {/* ===== REVIEW ===== */}
      {reviewMode && (
        
        <div
        className="container min-vh-100  justify-content-center align-items-center"
        style={{ minHeight: "100vh", overflowY: "auto" }}
      >
        <button className="btn btn-success mt-3" onClick={downloadPDF}>
              ⬇ Download PDF
            </button>
          <h3 className="text-center mb-4">Review Answers 🧠</h3>
          {questions.map((q, index) => {
            const userAns = answers[q.QUE_UID];
            return (
              <div key={q.QUE_UID} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <h6>
                    {index + 1}. {q.QUESTION}
                  </h6>
                  {["A", "B", "C", "D"].map((opt, i) => {
                    const isRight = opt === q.RIGHT_ANS;
                    const isUser = opt === userAns;
                    let cls = "border p-2 rounded mb-1";
                    if (isRight) cls += " bg-success text-white";
                    else if (isUser) cls += " bg-danger text-white";
                    return (
                      <div key={opt} className={cls}>
                        {opt}. {q[`OPT${i + 1}`]}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ===== EXAM ===== */}
      {!finish && (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
          <div className="card w-100 shadow" style={{ maxWidth: 700 }}>
            <div className="card-header bg-primary text-white">
              Question {currentIndex + 1} / {questions.length}
            </div>

            <div className="card-body">
              <h5>{currentQ.QUESTION}</h5>
              {["A", "B", "C", "D"].map((opt, i) => (
                <div
                  key={opt}
                  className={`p-3 mb-2 border rounded ${answers[currentQ.QUE_UID] === opt ? "bg-primary bg-opacity-10" : ""}`}
                  onClick={() => selectOption(opt)}
                  style={{ cursor: "pointer" }}
                >
                  {opt}. {currentQ[`OPT${i + 1}`]}
                </div>
              ))}
            </div>

            <div className="card-footer d-flex justify-content-between">
              <button
                className="btn btn-secondary"
                disabled={currentIndex === 0}
                onClick={() => setCurrentIndex(currentIndex - 1)}
              >
                ← Previous
              </button>

              {currentIndex === questions.length - 1 ? (
                <button
                  className="btn btn-success"
                  onClick={submitTest}
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Exam"}
                </button>
              ) : (
                <button
                  className="btn btn-primary"
                  disabled={!answers[currentQ.QUE_UID]}
                  onClick={() => setCurrentIndex(currentIndex + 1)}
                >
                  Next →
                </button>
              )}
            </div>

            {message && (
              <div
                className={`alert mt-2 ${status === "error" ? "alert-danger" : "alert-info"}`}
              >
                {message}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Exam;
